// A legal form is not a name.
//
// NO React or Redux imports: backend/tests/legalFormParity.test.mjs loads this
// file directly in Node and checks the list against the server's.
//
// Practitioners answer "Raison sociale" / "Entreprise" with what KIND of
// business they are ("Raison individuelle", "Sàrl"). That is true data about
// the entity and stays on the offer, but a form that prefills a NAME field
// from it prints the legal form as the insured's name. 2026-09-28: Convert to
// Policy prefilled "Entreprise / Cabinet" with "Raison individuelle" for an
// RC Pro sole proprietor (QT-2026-0117).
//
// Mirror of LEGAL_FORM_ONLY in backend/services/offerIdentity.js — the test is
// WHOLE-STRING, so "Cabinet Médical des Trois-Chêne Sàrl" survives and a bare
// "Sàrl" does not.
import { realText } from './references.js';

export const LEGAL_FORM_TOKENS = Object.freeze([
  // fr
  'raison individuelle', 'raison sociale', 'entreprise individuelle',
  'societe anonyme', 'societe a responsabilite limitee', 'societe simple',
  'societe en nom collectif', 'societe en commandite', 'sarl', 'sa', 'snc',
  'entreprise', 'societe', 'independant', 'independante', 'personne physique',
  'personne morale', 'cabinet individuel', 'association', 'fondation',
  // de
  'einzelunternehmen', 'einzelfirma', 'einzelperson', 'aktiengesellschaft',
  'ag', 'gmbh', 'kollektivgesellschaft', 'kommanditgesellschaft', 'verein',
  'stiftung', 'firma', 'unternehmen', 'selbstandig',
  // it
  'ditta individuale', 'societa anonima', 'sagl', 'spa',
  // en
  'sole proprietorship', 'sole trader', 'sole proprietor', 'self employed',
  'self-employed', 'individual', 'natural person', 'legal entity', 'company',
  'corporation', 'ltd', 'llc', 'inc', 'limited', 'business', 'n/a', 'na',
]);

const TOKENS = new Set(LEGAL_FORM_TOKENS);

/** Fold accents/case/punctuation and collapse spaces, as the server does. */
export function normaliseFormToken(s) {
  return String(s || '')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[.,;:()"']/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** True when the whole value is an entity type rather than somebody's name. */
export function isLegalFormOnly(value) {
  const n = normaliseFormToken(value);
  return Boolean(n) && TOKENS.has(n);
}

/** The value as a name, or '' when it is blank, a placeholder or a legal form. */
export function nameCandidate(value) {
  const v = realText(value);
  return v && !isLegalFormOnly(v) ? v : '';
}
